(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-size-chart"] && !Shopify.designMode) return;
  try {
    (() => {
    document.querySelectorAll('.product-size-chart').forEach((component) => {
      const productDetails = component.closest('.product-details');
      const inventory = productDetails?.querySelector('product-inventory');
      if (inventory && !inventory.contains(component)) {
        inventory.append(component);
        component.classList.add('product-size-chart--inline');
      }

      const chart = component.querySelector('[data-size-chart]');
      if (!chart) return;

      const sourceUnit = (chart.dataset.sourceUnit || 'cm').toLowerCase();
      const sourceIsImperial = sourceUnit.includes('in');
      const unitLabel = chart.querySelector('[data-size-unit]');
      const unitOptions = [...chart.querySelectorAll('[data-size-unit-option]')];
      const values = [...chart.querySelectorAll('[data-size-value]')];

      const formatValue = (value, unit) => {
        if (Number.isNaN(value)) return '—';
        const formatted = Number(value.toFixed(1)).toString();
        return unit === 'imperial' ? `${formatted}"` : formatted;
      };

      const renderUnit = (unit) => {
        values.forEach((cell) => {
          const sourceValue = Number.parseFloat(cell.dataset.sizeValue);
          if (Number.isNaN(sourceValue)) {
            cell.textContent = '—';
            return;
          }

          const centimeters = sourceIsImperial ? sourceValue * 2.54 : sourceValue;
          const inches = sourceIsImperial ? sourceValue : sourceValue / 2.54;
          cell.textContent = formatValue(unit === 'metric' ? centimeters : inches, unit);
        });

        unitLabel.textContent = unit === 'metric' ? 'cm' : 'in';
        unitOptions.forEach((option) => {
          const active = option.dataset.sizeUnitOption === unit;
          option.classList.toggle('is-active', active);
          option.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      };

      unitOptions.forEach((option) => {
        option.addEventListener('click', () => {
          renderUnit(option.dataset.sizeUnitOption);
        });
      });

      renderUnit('imperial');
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
